import { List, Map, fromJS } from 'immutable';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let topUp = state.get('top-up') || Map();
    let user = topUp.get(id) || Map();

    user = user
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0);

    return state.set(
        'top-up', topUp.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let topUp = state.get('top-up') || Map();
    let user = topUp.get(id) || Map();

    user = user
            .set('state', 'ERROR')
            .set('errors', fromJS(errors));

    return state.set(
        'top-up', topUp.set(id, user)
    );
}

export function form(state, { id, data }) {
    id = parseInt(id, 10);

    let topUp = state.get('top-up') || Map();
    let user = topUp.get(id) || Map();

    user = user
            .set('state', 'FORM')
            .set('data', fromJS(data))
            .set('errors', void 0);

    return state.set(
        'top-up', topUp.set(id, user)
    );
}

export function finish(state, { id, transaction, customer }) {
    id = parseInt(id, 10);

    let topUpEl = state.get('top-up') || Map();
    let user = topUpEl.get(id) || Map();

    user = user
            .set('state', 'FINISHED')
            .set('data', fromJS(transaction))
            .set('errors', void 0);

    state = state.set(
        'top-up', topUpEl.set(id, user)
    );

    if (!customer) {
        return state;
    }

    return state.setIn([ 'list', id, 'data' ], fromJS(customer));
}

export function clear(state, { id }) {
    id = parseInt(id, 10);

    return state.set(
        'top-up',
        (state.get(id) || Map()).set(id, void 0)
    );
}
